<!-- <form (ngSubmit)="uploadImage()">
    <input type="file" (change)="uploadFile($event)" accept="image/*">
    <button type="submit">Upload Image</button> -->
    <form  [formGroup]="form" >
 
            
             
    <label style="padding-right: 20px;"><b>Title:</b></label>  
    <mat-form-field *ngIf="!isLoadingResults" floatLabel="never">
      <input matInput  formControlName="title" required size="50" style="padding-right: 50px;"/>
    
      
    </mat-form-field>     
 
    <label style="padding-right: 20px; padding-left: 50px;">Description:</label>   
    <mat-form-field floatLabel="never">
      <input matInput  formControlName="description" required size="350" style="padding-right: 20px; min-width: 450px;"/>
   
      </mat-form-field>
 <br><br>
    <input type="file" (change)="onFileSelected($event)" />
    <br>
<button (click)="uploadFile()">Upload</button>
  </form>